import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { ControlLabel } from 'react-bootstrap';
import OptionFormattedMessage from 'components/OptionFormattedMessage';
import ModalForm from 'components/ModalForm';
import { ACTION_ROLES, messages as commonMessages } from 'common';
import styles from './styles.css';
import messages from './messages';

const CreateActionForm = ({ handleSubmit, show, onHide }) => (
  <ModalForm
    onHide={onHide}
    show={show}
    handleSubmit={handleSubmit}
    title={<FormattedMessage {...messages.createAction} />}
  >
    <ControlLabel className={styles.controlLabel} htmlFor="actionRole">
      <FormattedMessage {...messages.department} />
      <Field name="actionRole" component="select" className="form-control" required>
        <option />
        {
          ACTION_ROLES.map((role) => (
            <OptionFormattedMessage message={{ ...commonMessages[role] }} key={role} value={role} />
          ))
        }
      </Field>
    </ControlLabel>

    <ControlLabel className={styles.controlLabel} htmlFor="comment">
      <FormattedMessage {...messages.description} />
      <Field
        required
        name="comment"
        component="textarea"
        className="form-control"
      />
    </ControlLabel>
  </ModalForm>
);


CreateActionForm.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({ form: 'CreateActionForm', enableReinitialize: true })(CreateActionForm);



// WEBPACK FOOTER //
// ./src/components/CreateActionForm/index.js